module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"One Hollingdean: Parking, Zone 14 and the resident campaign","short_name":"One Hollingdean","start_url":"/","background_color":"#007A3D","theme_color":"#007A3D","display":"minimal-ui","icon":"src/assets/images/favicon.png","icon_options":{"purpose":"any maskable"},"theme_color_in_head":true,"cache_busting_mode":"none","legacy":true,"crossOrigin":"anonymous","include_favicon":true,"cacheDigest":null},
    },{
      plugin: require('../node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://one-hollingdean.com","stripQueryString":true},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
